var _g, _path, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRw({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4173cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 256H0V97.103a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828L512 256zM0 256h512v158.897a8.829 8.829 0 0 1-8.828 8.828H8.828A8.829 8.829 0 0 1 0 414.897V256z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M0 256h512v83.86H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.828 423.724h494.345a8.829 8.829 0 0 0 8.828-8.828v-75.034H0v75.034a8.828 8.828 0 0 0 8.828 8.828z",
    fill: "#73af00"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffe15a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.211 178.12l36.134-5.982-36.134-5.982 31.094-19.354-35.672 8.301 21.321-29.78-29.78 21.321 8.301-35.672-19.354 31.094-5.983-36.135-5.982 36.134-19.354-31.094 8.301 35.672-29.78-21.321 21.321 29.78-35.672-8.301 31.094 19.354-36.135 5.983 36.134 5.982-31.094 19.354 35.672-8.301-21.321 29.78 29.78-21.321-8.301 35.672 19.354-31.094 5.983 36.135 5.982-36.134 19.354 31.094-8.301-35.672 29.78 21.321-21.321-29.78 35.672 8.301-31.093-19.355zm-30.073 16.087c-12.189 0-22.069-9.88-22.069-22.069s9.88-22.069 22.069-22.069 22.069 9.88 22.069 22.069-9.88 22.069-22.069 22.069z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.14,
    cy: 172.14,
    r: 16.552
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRw);
export default __webpack_public_path__ + "static/media/rw.6037c5de80d70472587682fc3f5d83a6.svg";
export { ForwardRef as ReactComponent };